import React from "react";
import {Box, useMediaQuery} from "@mui/system";
import { Typography} from "@mui/material";

import {theme} from "../../../../../utils";
import {styles} from "./officeResources-helpers";
import FilePdfIcon from "../../../../../assets/images/svgs/file-pdf.svg";
import {DownloadButton, DownloadButtonType} from "../../../../../components";
import resourceData from "../../../../../assets/data/educationHub/resourceListData"

export const ResourceLists = ({ t }: any) => {
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))
    const listData = resourceData.offlineResources

    return (
        <Box mt={"50px"} flex={1} flexWrap={"wrap"} px={"31px"}>
            {listData.map((item, index) => {
                return (
                    <Box key={index + 1} flex={1} sx={styles.itemListWrapper} textAlign={"left"}>
                        <Box display={"flex"} sx={isMobileX ? { ...styles.mobileWrapper } : null}>
                            <Typography sx={styles.listTitle}>
                                {item.title}
                            </Typography>

                            <Box sx={{ display: "flex", ml: isMobileX ? "0px" : "30px", height: "25px", pl: "0px" }}>
                                <DownloadButton fileUrl={item?.fileUrl} buttonIcon={FilePdfIcon} buttonText="Open PDF" buttonType={DownloadButtonType.Pdf} />
                            </Box>
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}